export default __webpack_public_path__ + "static/media/qrcode.f7370aff.png";